import React, { useEffect, useRef } from "react";
import {
  select,
  axisLeft,
  axisBottom,
  scaleBand,
  scaleLinear
} from "d3"; // we will need d3.js

function AxisBottom({ scale, transform }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      select(ref.current).call(axisBottom(scale));
    }
  }, [scale]);

  return <g ref={ref} transform={transform} />;
}

function AxisLeft({ scale }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      select(ref.current).call(axisLeft(scale));
    }
  }, [scale]);

  return <g ref={ref} />;
}

function Bars({ data, color, height, scaleX, scaleY }) {
  return (
    <>
      {data.map(({ value, label }, index) => (
        <rect
          key={`bar-${label}`}
          x={scaleX(label)}
          y={scaleY(value)}
          width={scaleX.bandwidth()}
          height={height - scaleY(value)}
          fill={color[index % color.length]}
        />
      ))}
    </>
  );
}

const BarChart = ({width: tWidth, height: tHeight, color: chartColor, xRange, data}) => {
  const margin = { top: 10, right: 0, bottom: 20, left: 60 };
  const width = tWidth - margin.left - margin.right;
  const height = tHeight - margin.top - margin.bottom;

  let color;

  if(typeof chartColor === 'string') color = [chartColor];
  else color = chartColor.filter(item => item!== undefined);

  const scaleX = scaleBand()
    .domain(data.map(({ label }) => label))
    .range([0, width])
    .padding(0.5);
  const scaleY = scaleLinear()
    .domain([0, Math.max(...data.map(({ value }) => value))])
    .range([height, 0]);

  return (
    <svg
      width={width + margin.left + margin.right}
      height={height + margin.top + margin.bottom}
      style={{backgroundColor: 'white'}}
    >
      <g transform={`translate(${margin.left}, ${margin.top})`}>
        <AxisBottom scale={scaleX} transform={`translate(0, ${height})`} />
        <AxisLeft scale={scaleY} />
        <Bars data={data} color={color} height={height} scaleX={scaleX} scaleY={scaleY} />
      </g>
    </svg>
  );
}; export default BarChart;